import { NotificationsForm } from 'components/NotificationsForm/NotificationsFormComponent';
import NotificationsFormContainer from 'components/NotificationsForm/NotificationsFormContainer';

export { default as NotificationsForm } from 'components/NotificationsForm/NotificationsFormComponent';
export { default as NotificationsFormContainer } from 'components/NotificationsForm/NotificationsFormContainer';

export default {
  NotificationsForm,
  NotificationsFormContainer,
};
